import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parameters-options',
  templateUrl: './parameters-options.component.html',
  styleUrls: ['./parameters-options.component.less']
})
export class ParametersOptionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-options/parameters-options.component.ts